import { nextTick } from "vue";
import { createRouter, createWebHistory } from "vue-router";

import Home from "./components/HomePage.vue";
import NotFound from "./components/NotFound.vue";
import NewOurServicesPage from "./components/NewOurServicesPage.vue";
import NewOurProjectsPage from "./components/NewOurProjectsPage.vue";
import NewAboutUsPage from "./components/NewAboutUsPage2.vue";
import NewContactUsPage from "./components/NewContactUsPage.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: { title: "Home - Oillead Services" },
    },
     {
      path: "/contact",
      name: "newcontactuspage",
      component: NewContactUsPage,
      meta: { title: "Contact Us - Oillead Services" },
    },
     {
      path: "/about",
      name: "newaboutuspage",
      component: NewAboutUsPage,
      meta: { title: "About Us - Oillead Services" },
    },
     {
      path: "/projects",
      name: "newourprojectspage",
      component: NewOurProjectsPage,
      meta: { title: "Projects - Oillead Services" },
    },
     {
      path: "/services",
      name: "newourservicespage",
      component: NewOurServicesPage,
      meta: { title: "Services - Oillead Services" },
    },
    {
      path: "/:notFound(.*)",
      name: "NotFound",
      component: NotFound,
      meta: { title: "Not Found - Oillead Services" },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { left: 0, top: 0 };
  },
});

const DEFAULT_TITLE = "Oillead Services";
router.afterEach((to) => {
  nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
